import ScaledTemplate from '../Tabs/ScaledTemplate';
import * as CoreFns from '../utilities/CoreFns';
import * as SearchForAnEntityWithPath from '../utilities/SearchForAnEntityWithPath';
import * as ActionModifiers from '../ActionModifiers';
import * as ResponsiveFns from '../utilities/ResponsiveFns';

function App(props) {

  var isFEOrPU = props.isFEOrPU;
  
  var insetWidth = props.insetWidth;
  var overallWidth = props.overallWidth;
  var insetHeight = props.insetHeight;
  var expressedWidth = props.expressedWidth;
  var previousDApps = props.previousDApps;
  var handleChanges = props.handleChanges;
  var chains = props.chains;
  var changeTab = props.changeTab;

  var userNos = props.userNos;
  var currentList = props.currentList;


  function clickItem(aTemplate, aKey){
    return function(e){

      var pathDown = [isFEOrPU];
      var thisContract = aTemplate.con;
      var uuid = CoreFns.uuidScoped(userNos, currentList, pathDown, []);  
      var item = thisContract[isFEOrPU][aKey];
      var asChanges = SearchForAnEntityWithPath.getASChanges({v:item, as:thisContract.as, cn:thisContract.cn}, isFEOrPU, currentList, userNos);
      item.n = CoreFns.simplName(uuid);
      if (item.nv && item.nv.on){
        var uuid1 = CoreFns.uuidScoped(userNos, currentList, ['cn'], []);  
        var newItem;
        if (item.nv.on === 1){
          newItem = item.nv;
        }else{
          newItem = thisContract.cn[item.nv.on].nv;
        }
        var newNav = {ord:0, n:CoreFns.simplName(uuid1), nv:newItem};
        if (thisContract.cn){
          thisContract.cn[uuid1] = newNav;
        }else{
          thisContract.cn = {uuid1:newNav};
        }
        item.nv.on = uuid1;
        asChanges.push({t:'w', w:['cn', uuid1], n:newNav})
      }

      var ord = ResponsiveFns.getNextOrdDirect(currentList, pathDown);
      item.ord = ord;

      var panels = item._s;
      var panelKeys = CoreFns.sortedKeyList(panels);
      var firstPanelKey = '1';
      if (panelKeys.length > 0){
        firstPanelKey = panelKeys[0];
      }

      var oldChainId = CoreFns.getChainDAppIsOn(currentList);
      var newChainId = CoreFns.getChainDAppIsOn(thisContract);
      var smartContractsTouched = ActionModifiers.doAPage([isFEOrPU, aKey], item, 'scUsage', false, thisContract, chains, changeTab);

      smartContractsTouched.forEach((aSCTouched, index)=>{
        if (aSCTouched.n === 'eS' || aSCTouched.n === 'eV' || aSCTouched.n === 'formulaES'){
        }else if (aSCTouched.n === 'existingContractFn'){
        }else if (aSCTouched.n === 'inP' || aSCTouched.n === 'formulaINP' || aSCTouched.n === 'gV' || aSCTouched.n === 'formulaGV'){
          var thisINPV = aSCTouched.t.v;
          if (thisINPV[0] === isFEOrPU && thisINPV[1] === aKey){
            thisINPV[1] = uuid; 
            aSCTouched.t.v = thisINPV;
          }
        }else if (aSCTouched.n === 'changeInputValue'){
          var relevant = aSCTouched.t;
          var origTBeyond = relevant.t.substr(16).split(' ');
          if (origTBeyond[0] === isFEOrPU && origTBeyond[1] === aKey){
            origTBeyond[1] = uuid;
            relevant.t = 'changeInputValue' + origTBeyond.join(' ');
          }
        }else{
        }
      })


      if (oldChainId === newChainId){
        var alreadyDone = [];
        var currentSC = currentList.sc;
        var currentSCKeys = Object.keys(currentSC);

        function doReplacement(originalSCKey){
          for (var i = 0; i < alreadyDone.length; i++){
            if (alreadyDone[i].oldKey === originalSCKey){
              return alreadyDone[i].newKey;
            }
          }
          var oldSC = thisContract.sc[originalSCKey];
          if (oldSC){
            if (oldSC.addSet[oldChainId]){
              var oldAddr = oldSC.addSet[oldChainId].addr;
              for (var j = 0; j < currentSCKeys.length; j++){
                var origContracts = currentSC[currentSCKeys[j]];
                if (origContracts.addSet[oldChainId]){
                  if (origContracts.addSet[oldChainId].addr === oldAddr){
                    alreadyDone.push({newKey:currentSCKeys[j], oldKey:originalSCKey});
                    return currentSCKeys[j];
                  }
                }
              }

              var uuidX = CoreFns.uuidScoped(userNos, currentList, ['sc'], []);  
              asChanges.push({t:'w',w:['sc',uuidX],n:oldSC})
              alreadyDone.push({newKey:uuidX, oldKey:originalSCKey});
              return uuidX;
            }
          }
          return originalSCKey;
        }

        smartContractsTouched.forEach((aSCTouched, index)=>{

          if (aSCTouched.n === 'eS' || aSCTouched.n === 'eV' || aSCTouched.n === 'formulaES'){
            var keyHere = aSCTouched.t.s;
            var newKey = doReplacement(keyHere);
            if (newKey !== keyHere){
              aSCTouched.t.s = newKey;
            }
          }else if (aSCTouched.n === 'existingContractFn'){
            var pieces = aSCTouched.t.t.split(' ');
            var keyHere1 = pieces[1];
            var newKey1 = doReplacement(keyHere1);
            if (newKey1 !== keyHere1){
              pieces[1] = newKey1;
              aSCTouched.t.t = pieces.join(' ');
            }
          }else if (aSCTouched.n === 'inP' || aSCTouched.n === 'gV' || aSCTouched.n === 'changeInputValue' || aSCTouched.n === 'formulaINP' || aSCTouched.n === 'formulaGV'){
          }else{
            console.log(aSCTouched);
          }
        })

      }else{
        var involveES = smartContractsTouched.filter((aSCTouched, index)=>{
          return (aSCTouched.n === 'eS' || aSCTouched.n === 'eV' || aSCTouched.n === 'formulaES')
        });
        if (involveES.length > 0){
          var p = window.confirm('The page that you are importing from is from a different blockchain than your current dApp. This means that the contracts from the imported page will not be valid. Please confirm if you would like to proceed');
          if (!p){
            return;
          }
        }
      }

      var changes = asChanges.concat([{t:'w',w:pathDown.concat([uuid]),n:item}]);
      handleChanges(uuid, changes, firstPanelKey);
      e.stopPropagation();
    }

  }

//

   var templatesOut = [];

  var w = (expressedWidth - 180);
  var h = (expressedWidth - 180) * (insetHeight - 42)/insetWidth;

   previousDApps.forEach((aTemplate, index)=>{

    var cListCleaned = aTemplate.con;
    var feOrPU = cListCleaned[isFEOrPU];

    if (feOrPU){
      var keys = Object.keys(feOrPU);
      keys.forEach((aKey, index2)=>{
        var inside = <ScaledTemplate chains={chains} overallWidth={overallWidth} w={w} h={h} error={false} whichFEOrPU={{t:isFEOrPU, v:aKey}} currentList={cListCleaned} onClick={clickItem(aTemplate, aKey)} offsetTop={0} offsetLeft={0}/>
        var thisFEOrPU = cListCleaned[isFEOrPU][aKey];
        var elab = aTemplate.n + ' - ' + thisFEOrPU.n;
        try{
          templatesOut.push(<div key={index + ' ' + index2} className="col-md-5 cardBlockchain col-11" onClick={clickItem(aTemplate, aKey)}> <center>
            {inside}{elab}</center>
          </div> )
  //        
        }catch(err){
          console.log(err);
        }
      })
    }
//
  })  

//
     

  return <div className="container py-5">
          <div className='row'>
            {templatesOut}
          </div>
        </div>

}


//
export default App;
